import { STATUS_CODES } from 'utils/Constants'
import { MiddlewareFunction } from './index'
import BLOG_ARTICLE from 'components/Blog/BlogArticle.gql'
import { BlogArticle, BlogArticleVariables } from 'graph/BlogArticle'

export const handleBlogRedirects: MiddlewareFunction = async (ctx, next) => {
  const { nextContext, apolloClient } = ctx
  const { req, query } = nextContext
  const isBlogRoute = req?.url?.includes('/blogs/')

  if (!isBlogRoute) {
    return next()
  }

  const { data } = await apolloClient.query<BlogArticle, BlogArticleVariables>({
    query: BLOG_ARTICLE,
    variables: { slug: query?.slug as string },
  })

  return handleBlogArticle404({ ...ctx, data }, next)
}

export const handleBlogArticle404: MiddlewareFunction = async ({ data, nextContext }, next) => {
  if (!data.article) {
    nextContext.res!.statusCode = 404

    return {
      isServerSideRedirect: false,
      errorCode: STATUS_CODES.CODE404,
    }
  }

  return next()
}
